import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { callApi, fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint } from '../../../constants/routes'

import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'
import EditableDisplayField from '../../utils/editable-display-field'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// each list keeps its own delete form entry so one list's error is not shown on another
const deleteFormId = (endpoint) => `delete-${endpoint}`

const mapStateToProps = (state, ownProps) => {
    return {
        deleteForm: state.forms.find(f => f.id === deleteFormId(ownProps.endpoint))
    }
}

const OptionList = ({ dispatch, endpoint, options, singular, deleteForm }) => {
    const [showForm, setShowForm] = useState(false)

    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint(endpoint, 'LIST')))
    }, [dispatch, endpoint])

    if (!options) {
        return null
    }

    const handleDelete = (option) => {
        let deleteMe = window.confirm(`Are you sure you want to delete ${option.name}`)
        if (deleteMe) {
            dispatch(callApi(apiResourceEndpoint(endpoint, 'DELETE', option.id), {}, deleteFormId(endpoint)))
        }
    }

    // options that are still referenced by a chef cannot be deleted, so show
    // the reason the api gave back instead of failing silently
    const renderDeleteError = () => {
        if (!deleteForm || deleteForm.status !== 'ERROR' || !deleteForm.body) {
            return null
        }
        return (
            <div className="alert alert-danger w-100">
                {String(deleteForm.body).replace(/^\d+:\s*/, '')}
            </div>
        )
    }

    const renderOptions = () => {
        let allOptions = []
        options.forEach(option => {
            allOptions.push(
                <div key={option.id} className="item">
                    <EditableDisplayField
                        label="Name"
                        display={option.name}
                        dataObj={option}
                        endpoint={endpoint}
                        extraClass="field name"
                        inTable={true}
                        fields={[{
                            type: 'text',
                            field: 'name',
                            required: true
                        }]} />
                    <EditableDisplayField
                        label="Description"
                        display={option.description}
                        dataObj={option}
                        endpoint={endpoint}
                        extraClass="field name"
                        inTable={true}
                        fields={[{
                            type: 'text',
                            field: 'description'
                        }]} />
                    <EditableDisplayField
                        label="Order"
                        display={option.order}
                        dataObj={option}
                        endpoint={endpoint}
                        extraClass="field name"
                        inTable={true}
                        fields={[{
                            type: 'number',
                            field: 'order'
                        }]} />
                    <span className="remove" title="Delete" onClick={() => handleDelete(option)}>
                        <FontAwesomeIcon icon="times" />
                    </span>
                </div>
            )
        })
        return <div className="ticket-items">{allOptions}</div>
    }

    const submitFX = (formData, formId) => {
        dispatch(callApi(apiResourceEndpoint(endpoint, 'CREATE'), formData, formId))
    }

    const successFX = (itemId) => {
        setShowForm(false)
    }

    const renderAddForm = () => {
        if (!showForm) {
            return null
        }
        return (
            <div className="ticket-items">
                <div className="item">
                    <SHSForm submitFX={submitFX} successFX={successFX} showCancel={true} cancelAction={() => setShowForm(false)}>
                        <InputElement
                            id="name"
                            label="Name"
                            type="text"
                            extraClass="flex-50"
                            required />
                        <InputElement
                            id="description"
                            label="Description"
                            type="text"
                            extraClass="flex-50"
                        />
                        <InputElement
                            id="order"
                            label="Order"
                            type="number"
                            default={0}
                            extraClass="flex-50"
                            required />
                    </SHSForm>
                </div>
            </div>
        )
    }

    const renderActionButton = () => {
        if (showForm) {
            return null
        }
        return (
            <div className="btn white bordered centered" onClick={() => setShowForm(true)}>
                Add {singular} +
            </div>
        )
    }

    return (
        <>
            {renderDeleteError()}
            {renderOptions()}
            {renderAddForm()}
            {renderActionButton()}
        </>
    )
}

export default connect(mapStateToProps)(OptionList)
